const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/StartPage/StartPageModal.tsx';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Icon,
    IconButton,
    Link,
} from '@mui/material';
import textMap from 'App/pages/StartPage/translations';
import { useIntl } from 'react-intl';
import React, { ReactNode } from 'react';
import { css } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';
import { getConfiguration } from 'App/utils/clientSetupGetRessource';
import { linkStyle } from '../DashboardPage/Components/appointmentCards/styles';

const backBtnStyle = css`
    margin-bottom: ${theme.spacing(1.8)};
    color: ${theme.palette.primary.main};
    padding: ${theme.spacing(1)};
`;

const contentTitleStyle = css`
    font-weight: 500;
`;

const closeBtnStyle = css`
    position: absolute;
    right: 8px;
    top: 8px;
`;

interface Props {
    closeModal: () => void;
    backToInvCode: () => void;
}

const actionButton = (label: string, iconName: string, onClick?: () => void) => {
    return (
        <Button variant="outlined" className={backBtnStyle} startIcon={<Icon className={iconName} />} onClick={onClick}>
            {label}
        </Button>
    );
};

const createModalActionSection = (title: string, text: string, action: ReactNode) => {
    return (
        <>
            <p className={contentTitleStyle}>{title}</p>
            <p>{text}</p>
            <DialogActions>{action}</DialogActions>
        </>
    );
};

export const StartPageModal = (props: Props) => {
    const { formatMessage } = useIntl();
    const { closeModal, backToInvCode } = props;

    const configuration = getConfiguration();
    const helpLink = configuration.urls.loginHelp;

    return (
        <Dialog open={true} onClose={closeModal}>
            <DialogTitle>
                {formatMessage(textMap.modalTitle)}
                <IconButton onClick={closeModal} className={closeBtnStyle}>
                    <Icon className={'icons8-delete'} />
                </IconButton>
            </DialogTitle>

            <Divider />

            <DialogContent>
                {createModalActionSection(
                    formatMessage(textMap.noSMSCodeTitle),
                    formatMessage(textMap.noSMSCodeText),
                    actionButton(formatMessage(textMap.goBackBtn), 'icons8-arrow-left', backToInvCode)
                )}
                {helpLink
                    ? createModalActionSection(
                          formatMessage(textMap.registeredAndNoSMSTitle),
                          formatMessage(textMap.registeredAndNoSMSText),
                          <Link className={linkStyle} href={helpLink} underline="none">
                              {actionButton(formatMessage(textMap.contactDetailsBtn), 'icons8-contacts')}
                          </Link>
                      )
                    : null}
            </DialogContent>
        </Dialog>
    );
};
